import { useState } from "react";

export const useFormInput = (initialValue = "") => {

    const [ value, setValue ] = useState(initialValue);
    
    const handleChange = async e => {

        const tempValue = await e.currentTarget.value;
        setValue(tempValue);
    }

    return {

        value,
        reset: (newValue) => setValue(newValue),
        onIonChange: handleChange,
        onKeyUp: handleChange
    };
}

export const validateForm = fields => {

	let errors = [];
	var tmp;

	fields.forEach(field => {

		if (field.required) {

			const fieldValue = field.input.state.value;

			if (fieldValue === "") {

				const error = {

					id: field.id,
					message: `Please check your ${ field.id }`,
				};

				errors.push(error);
			}
		}
		if (field.id == "password") {
			tmp = field.input.state.value;
		}
		if (field.id == "cpassword") {
			const cValue = field.input.state.value;
			if (cValue !== tmp) {

				const error = {

					id: field.id,
					message: `Passwords didn’t match`,
				};

				errors.push(error);
			}
		}
	});

	return errors;
}